module.exports = [{
      plugin: require('../node_modules/@qite/gatsby-source-tide/gatsby-browser.js'),
      options: {"plugins":[],"host":"https://tide-thalassa8624.tidesoftware.be","apiKey":"YBrYfc0S0fdrYTR0YYJKTYcgKIuQ2FwFPpOQLTel3ALVS4j7VsRxvon8cZAXvwFO","isPreview":false,"ignoreSslErrors":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
